import { Address } from '@thirdweb-dev/sdk';
import { Position } from '@cryptoalgebra/kim-sdk';
import { Pool, PoolDayData } from '@app/types/pool';
import { useAsync } from 'react-use';
import { useContract } from '@thirdweb-dev/react-core';
import { algebraPoolABI } from '../../../abis/v3';

export function usePositionApr(
  poolId: Address,
  position: Position | undefined,
  pool: Pool | undefined | null,
  poolFeeData: PoolDayData[] | undefined,
  nativePrice: string | undefined
) {
  const { contract: algebraPool } = useContract(poolId, algebraPoolABI);

  const { value } = useAsync(async () => {
    if (!pool || !poolFeeData || !nativePrice || !algebraPool || !position)
      return;

    try {
      const liquidity = await algebraPool.call('liquidity');

      const poolDayFees =
        poolFeeData &&
        Boolean(poolFeeData.length) &&
        Number(poolFeeData[0].feesUSD);

      const yearFee = poolDayFees && poolDayFees * 365;

      const liquidityRelation =
        position &&
        liquidity &&
        Number(position.liquidity.toString()) / Number(liquidity);

      const [amount0, amount1] = position
        ? [position.amount0.toSignificant(), position.amount1.toSignificant()]
        : [0, 0];

      const tvl =
        pool &&
        Number(pool.token0.derivedMatic) *
          Number(nativePrice) *
          Number(amount0) +
          Number(pool.token1.derivedMatic) *
            Number(nativePrice) *
            Number(amount1);

      return (
        liquidityRelation &&
        yearFee &&
        tvl &&
        ((yearFee * liquidityRelation) / tvl) * 100
      );
    } catch {
      return 0;
    }
  }, [algebraPool, poolId, position, pool, poolFeeData, nativePrice]);

  return value;
}
